export * from './response-map.constant';
export * from './api-endpoint.constant';
export * from './ipn-result-for-vnpay.constant';
export * from './regex.constant';

export const VNP_VERSION = '2.1.0';
export const VNP_DEFAULT_COMMAND = 'pay';
export const CURR_CODE_VND = 'VND';
